<template>
  <form @submit.prevent="onSubmit" id="form" class="bg-teal-50">
    <div class="mx-auto max-w-screen-xl pt-4 px-4 sm:px-6 lg:px-8">
      <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
        <div class="md:grid md:grid-cols-3 md:gap-6">
          <div class="md:col-span-1">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Algemeen
            </h3>
            <p class="mt-1 text-sm leading-5 text-gray-500">
              Geldigheid en template verzekeringsbewijs. Standaard template
              Solvas met juiste verzekeraar aanduiden.
            </p>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="grid grid-cols-6 gap-6">
              <div class="col-span-6 sm:col-span-3">
                <label
                  for="start"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Van
                </label>
                <datepicker
                  required
                  id="start"
                  :language="nl"
                  v-model="start"
                  format="dd MMMM yyyy"
                  class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <label
                  for="end"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Tot
                </label>
                <datepicker
                  :language="nl"
                  :disabledDates="disabledDates"
                  id="end"
                  v-model="end"
                  format="dd MMMM yyyy"
                  class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <label
                  for="template"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Template
                </label>
                <select
                  v-model="template"
                  disabled
                  id="template"
                  class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                >
                  <option>Solvas</option>
                  <option>TVM</option>
                  <option>Vivium</option>
                </select>
              </div>

              <div
                v-if="template === 'Solvas'"
                class="col-span-6 sm:col-span-3"
              >
                <label
                  for="insurer"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Verzekeraar
                </label>
                <select
                  v-model="insurer"
                  @change="setInsurerAddress(insurer.address)"
                  id="insurer"
                  class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                >
                  <option></option>
                  <option
                    v-for="insurer in insurers"
                    :value="insurer"
                    :key="insurer.id"
                    >{{ insurer.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
        <div class="md:grid md:grid-cols-3 md:gap-6">
          <div class="md:col-span-1">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Verzekeraar
            </h3>
            <p class="mt-1 text-sm leading-5 text-gray-500">
              Naam en adres verzekeraar zoals aangegeven in vak 11 op het
              verzekeringsbewijs.
            </p>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="grid grid-cols-6 gap-6">
              <div class="col-span-6 sm:col-span-3">
                <label
                  for="name"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Naam
                </label>
                <input
                  v-model="insurer.name"
                  id="name"
                  class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
              <div class="col-span-6 grid grid-cols-6 gap-6">
                <div class="col-span-6 sm:col-span-3">
                  <label
                    for="fsma"
                    class="block text-sm font-medium leading-5 text-gray-700"
                    >FSMA nummer
                  </label>
                  <input
                    v-model="insurer.fsma"
                    id="fsma"
                    class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                  />
                </div>
                <div class="col-span-6 sm:col-span-3">
                  <label
                    for="phone_number"
                    class="block text-sm font-medium leading-5 text-gray-700"
                    >Tel. bij ongeval
                  </label>
                  <input
                    v-model="insurer.phoneNumber"
                    id="phone_number"
                    class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                  />
                </div>
              </div>

              <div class="col-span-6">
                <label
                  for="address"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Adres
                </label>
                <input
                  v-model="insurerAddress"
                  id="address"
                  class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <label
                  for="postal_code"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Postcode
                </label>
                <input
                  v-model="insurer.address.postalCode"
                  id="postal_code"
                  class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <label
                  for="city"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Gemeente
                </label>
                <input
                  v-model="insurer.address.town"
                  id="city"
                  class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
        <div class="md:grid md:grid-cols-3 md:gap-6">
          <div class="md:col-span-1">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Voertuig
            </h3>
            <p class="mt-1 text-sm leading-5 text-gray-500">
              Detailgegevens van het voertuig.
            </p>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="grid grid-cols-6 gap-6">
              <div class="col-span-6 sm:col-span-3">
                <label
                  for="license_plate"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Nummerplaat
                </label>
                <input
                  v-model="vehicle.licensePlate"
                  id="license_plate"
                  class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <label
                  for="code"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Categorie
                </label>
                <select
                  v-model="vehicle.code"
                  id="code"
                  class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                >
                  <option
                    v-for="code in ['A', 'B', 'C', 'D', 'E', 'F', 'G']"
                    :value="code"
                    :key="code"
                    >{{ code }}. {{ categoryCodes[code] }}
                  </option>
                </select>
              </div>

              <div class="col-span-6 sm:col-span-3">
                <label
                  for="brand"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Merk
                </label>
                <input
                  v-model="vehicle.brand"
                  id="brand"
                  class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <label
                  for="model"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Model
                </label>
                <input
                  v-model="vehicle.model"
                  id="model"
                  class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
        <div class="md:grid md:grid-cols-3 md:gap-6">
          <div class="md:col-span-1">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Verzekeringsnemer
            </h3>
            <p class="mt-1 text-sm leading-5 text-gray-500">
              Naam en adres verzekeringsnemer.
            </p>
            <div class="mt-4 flex" v-if="vehicle.driver">
              <div class="flex items-center">
                <input
                  v-model="radio"
                  value="client"
                  @change="setRadio($event.target.value)"
                  id="client"
                  type="radio"
                  class="form-radio h-4 w-4 text-teal-400 transition duration-150 ease-in-out"
                />
                <label for="client" class="ml-3">
                  <span
                    class="block text-sm leading-5 font-medium text-gray-700"
                    >Klant
                  </span>
                </label>
              </div>
              <div class="ml-12 flex items-center">
                <input
                  v-model="radio"
                  value="driver"
                  @change="setRadio($event.target.value)"
                  id="driver"
                  type="radio"
                  class="form-radio h-4 w-4 text-teal-400 transition duration-150 ease-in-out"
                />
                <label for="driver" class="ml-3">
                  <span
                    class="block text-sm leading-5 font-medium text-gray-700"
                    >Bestuurder
                  </span>
                </label>
              </div>
            </div>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="grid grid-cols-6 gap-6">
              <div class="col-span-6 sm:col-span-3">
                <label
                  for="client_name"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Naam
                </label>
                <input
                  v-model="client.name"
                  id="client_name"
                  class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
              <div class="col-span-6 sm:col-span-3">
                <label
                  for="policy_number"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Polisnummer
                </label>
                <input
                  v-model="policyNumber"
                  id="policy_number"
                  class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6">
                <label
                  for="client_address"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Adres
                </label>
                <input
                  v-model="client.address.address"
                  id="client_address"
                  class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <label
                  for="client_postal_code"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Postcode
                </label>
                <input
                  v-model="client.address.postalCode"
                  id="client_postal_code"
                  class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>

              <div class="col-span-6 sm:col-span-3">
                <label
                  for="client_city"
                  class="block text-sm font-medium leading-5 text-gray-700"
                  >Gemeente
                </label>
                <input
                  v-model="client.address.town"
                  id="client_city"
                  class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-teal focus:border-teal-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-6 flex justify-end">
        <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
          <div class="flex">
            <div class="flex items-center">
              <input
                v-model="format"
                value="pdf"
                id="pdf"
                type="radio"
                class="form-radio h-4 w-4 text-teal-400 transition duration-150 ease-in-out"
              />
              <label for="pdf" class="ml-3">
                <span class="block text-sm leading-5 font-medium text-gray-700"
                  >Pdf
                </span>
              </label>
            </div>
            <div class="ml-12 flex items-center">
              <input
                v-model="format"
                value="docx"
                id="docx"
                type="radio"
                class="form-radio h-4 w-4 text-teal-400 transition duration-150 ease-in-out"
              />
              <label for="docx" class="ml-3">
                <span class="block text-sm leading-5 font-medium text-gray-700"
                  >Word
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="py-8 flex items-center justify-end">
        <p v-if="submitError" class="mr-6 text-sm text-red-600">
          {{ submitError }}
        </p>
        <div v-if="loading" class="loader mr-6"></div>
        <span class="inline-flex rounded-md shadow-sm">
          <button
            type="submit"
            class="inline-flex items-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-teal-600 hover:bg-teal-500 focus:outline-none focus:border-teal-700 focus:shadow-outline-teal active:bg-teal-700 transition ease-in-out duration-150"
          >
            <span>Verzenden</span>
          </button>
        </span>
      </div>
    </div>
  </form>
</template>

<script>
import Vue from 'vue';
import Datepicker from 'vuejs-datepicker';
import { nl } from 'vuejs-datepicker/dist/locale';
import axios from 'axios';
import fileSaver from 'file-saver';
import { getSFClient } from '@/auth';
import { add, lastDayOfMonth, startOfToday } from 'date-fns';

export default Vue.extend({
  name: 'Forms',
  components: {
    Datepicker
  },
  props: ['vehicle', 'insurance', 'customer'],
  data() {
    return {
      nl,
      start: new Date(),
      end: '',
      template: 'Solvas',
      client: {
        address: {}
      },
      insurer: {
        address: {}
      },
      insurerAddress: '',
      policyNumber: '',
      insurers: [],
      vehicleTypes: [],
      radio: '',
      format: 'pdf',
      loading: false,
      submitError: '',
      categoryCodes: {
        A: 'Personenauto',
        B: 'Motorrijwiel',
        C: 'Vrachtwagen of trekker',
        D: 'Bromfiets',
        E: 'Autobus',
        F: 'Aanhangwagen of oplegger',
        G: 'Overige'
      }
    };
  },
  computed: {
    disabledDates() {
      return {
        to: this.start
      };
    }
  },
  methods: {
    setInsurerAddress(address) {
      if (address) {
        this.insurerAddress = address.street + ' ' + address.streetNumber;
      }
    },
    // DIV upload: PDF only provides an FSMA number (e.g. "02796"), not an insuranceCompany id like Brio.
    // Normalises leading zeros so "02796" and "2796" match the same insurer.
    normalizeFsma(fsma) {
      const digits = String(fsma ?? '').replace(/\D/g, '');
      if (!digits) return null;
      const n = parseInt(digits, 10);
      return Number.isNaN(n) ? null : n;
    },
    setInsurerByFsma(fsma) {
      const target = this.normalizeFsma(fsma);
      if (target == null) return;

      const match = this.insurers.find(
        x => this.normalizeFsma(x.fsma) === target
      );
      if (match) {
        this.insurer = match;
        this.setInsurerAddress(match.address);
      }
    },
    async setRadio(value) {
      this.radio = value;
      if (value === 'driver') {
        if (this.vehicle.driver) {
          this.client = this.vehicle.driver;
          this.client.name = `${this.client.lastName} ${this.client.firstName}`;
          if (!this.client.address) {
            this.client.address = {};
          }
        }
      }
    },
    onSubmit: async function(e) {
      e.preventDefault();
      this.submitError = '';

      if (!(this.start && this.end)) {
        this.submitError = 'Vul de start- en einddatum in.';
        return;
      }
      if (!(this.insurer && this.insurer.name && this.insurer.address)) {
        this.submitError = 'Selecteer een verzekeraar.';
        return;
      }
      if (!(this.client && this.client.name && this.client.address)) {
        this.submitError = 'Vul de gegevens van de verzekeringsnemer in.';
        return;
      }
      if (!this.vehicle.licensePlate) {
        this.submitError = 'Vul het nummerplaat in.';
        return;
      }
      if (!this.policyNumber) {
        this.submitError = 'Vul het polisnummer in.';
        return;
      }

      const data = {
        sDag: this.start.getDate(),
        sMaand: this.start.getMonth() + 1,
        sJaar: this.start.getFullYear(),
        eDag: this.end.getDate(),
        eMaand: this.end.getMonth() + 1,
        eJaar: this.end.getFullYear(),
        template: this.template,
        polisnummer: this.policyNumber,
        mNaam: this.insurer.name,
        mFsma: this.insurer.fsma,
        mTel: this.insurer.phoneNumber,
        mAdres: this.insurerAddress,
        mPostcode: this.insurer.address.postalCode,
        mGemeente: this.insurer.address.town,
        vnNaam: this.client.name,
        vnAdres: this.client.address.address,
        vnPostcode: this.client.address.postalCode,
        vnGemeente: this.client.address.town,
        nummerplaat: this.vehicle.licensePlate,
        categorie: this.vehicle.code,
        addTrailer:
          this.vehicle.code !== 'B' &&
          this.vehicle.code !== 'D' &&
          this.vehicle.code !== 'F',
        merk: this.vehicle.brand,
        model: this.vehicle.model || ''
      };

      this.loading = true;
      try {
        const response = await axios.post(
          'https://functions.solvas.be/api/render?code=VQcESfY8bxXG1h39V/4BPyKLN2k5sQLqhJarAXRGCGhKxdDbeHKqXQ==',
          {
            template: 'Solvas.docx',
            fileName: data.nummerplaat,
            type: 'VB',
            format: this.format,
            data
          },
          { responseType: 'blob' }
        );
        const blob = new Blob([response.data], {
          type: response.headers['content-type']
        });
        const fileName = `${data.nummerplaat}.${this.format}`;
        fileSaver.saveAs(blob, fileName);
      } catch (err) {
        this.submitError = 'Genereren mislukt. Probeer opnieuw.';
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    vehicle(vehicle) {
      if (vehicle.driver?.address) {
        this.setRadio('driver');
      }
    },
    customer(customer) {
      if (!customer || !customer.name) return;

      this.client.name = customer.name;
      if (customer.address) {
        this.client.address = customer.address;
      }
    },
    // Extensions below are for DIV registration PDF upload.
    // Brio license plate search still works unchanged via insuranceCompany + renewalDate.
    insurance: {
      handler(insurance) {
        if (!insurance) return;

        if (insurance.policyNumber) {
          this.policyNumber = insurance.policyNumber;
        }
        if (this.insurers.length) {
          // Brio search: match insurer by database id
          this.insurer = this.insurers.find(
            x => x.id === insurance.insuranceCompany
          );
          // DIV upload: fallback match by FSMA number from PDF
          if (!this.insurer && insurance.fsma) {
            this.setInsurerByFsma(insurance.fsma);
          }
          // DIV upload: fallback match by insurer name (e.g. "TVM Belgium") when FSMA does not match
          if (!this.insurer && insurance.insurerName) {
            const words = insurance.insurerName
              .toLowerCase()
              .split(/[^a-z0-9]+/)
              .filter(word => word.length > 2);
            this.insurer = this.insurers.find(x =>
              words.some(word =>
                String(x.name || '')
                  .toLowerCase()
                  .includes(word)
              )
            );
            if (this.insurer) {
              this.setInsurerAddress(this.insurer.address);
            }
          } else if (this.insurer) {
            this.setInsurerAddress(this.insurer.address);
          }
        }
        if (insurance.registrationDate) {
          const [day, month, year] = insurance.registrationDate.split('/');
          this.start = new Date(Number(year), Number(month) - 1, Number(day));
          // DIV upload: validity = start date + 2 months (Brio uses renewalDate below)
          const divRegistration =
            !insurance.insuranceCompany &&
            (insurance.fsma || insurance.insurerName);
          this.end = divRegistration
            ? add(this.start, { months: 2 })
            : lastDayOfMonth(add(this.start, { years: 1 }));
          return;
        }
        // Brio search: end date based on policy renewal date
        if (!insurance.renewalDate) return;

        const renewalDate = new Date(
          `${insurance.renewalDate.substring(
            2,
            4
          )}/${insurance.renewalDate.substring(
            0,
            2
          )}/${new Date().getFullYear()}`
        );
        if (startOfToday() >= renewalDate) {
          this.end = lastDayOfMonth(add(renewalDate, { years: 1 }));
        } else {
          this.end = lastDayOfMonth(renewalDate);
        }
      },
      immediate: true
    }
  },
  async mounted() {
    const client = await getSFClient();
    const {
      data: { data: insurers }
    } = await client.get('/companies?type=INSURANCE_COMPANY');
    this.insurers = insurers.filter(x => x.fsma !== null);

    // DIV upload: PDF may arrive before the insurer list has loaded.
    // The insurance watcher may have already run with an empty insurers array — retry here.
    if (this.insurance && !this.insurance.insuranceCompany) {
      if (this.insurance.fsma) {
        this.setInsurerByFsma(this.insurance.fsma);
      }
      if (!this.insurer && this.insurance.insurerName) {
        const words = this.insurance.insurerName
          .toLowerCase()
          .split(/[^a-z0-9]+/)
          .filter(word => word.length > 2);
        this.insurer = this.insurers.find(x =>
          words.some(word =>
            String(x.name || '')
              .toLowerCase()
              .includes(word)
          )
        );
        if (this.insurer) {
          this.setInsurerAddress(this.insurer.address);
        }
      }
    }
  }
});
</script>
<style scoped>
.loader {
  border: 4px solid #4fd1c5;
  border-top: 4px solid #319795;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
